var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-page" }, [
    _c("div", { staticClass: "inner-box" }, [
      _c("h1", [_vm._v("E海通财PC商城首页")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-text" }, [
        _c("input", {
          directives: [
            {
              name: "account",
              rawName: "v-account",
              value: 10,
              expression: "10"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userId,
              expression: "userId"
            }
          ],
          staticClass: "text",
          attrs: { type: "text", placeholder: "请输入账号" },
          domProps: { value: _vm.userId },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.userId = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-text" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.tradePassword,
              expression: "tradePassword"
            }
          ],
          staticClass: "text",
          attrs: { type: "password", placeholder: "请输入密码" },
          domProps: { value: _vm.tradePassword },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.tradePassword = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-text" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.phonePassword,
              expression: "phonePassword"
            }
          ],
          staticClass: "text",
          attrs: { type: "password", placeholder: "请输入通讯密码" },
          domProps: { value: _vm.phonePassword },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.phonePassword = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "ared" }, [_vm._v(_vm._s(_vm.errorTip))]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-box" }, [
        _c("button", { on: { click: _vm.submitLogin } }, [_vm._v("登录")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c40149d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c40149d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = null
// module chunks = 